<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <v-icon>apps</v-icon>
      </div>
      <div>
        <div><span>Tableau de bord</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest" v-html="staticText"></section>
  </div>
</template>

<script>
export default {
  name: 'GestionnaireHome',
  data () {
    return {
      staticText: ''
    }
  },
  async created () {
    await this.axios({
      method: 'GET',
      url: 'statictexts/gestionnaire_tableau_de_bord/'
    }).then(response => {
      this.staticText = response.data.text
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/style/styleAppErnest";
</style>
